import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import {
  AGENT_BANK_LIST,
  AGENT_LIST,
  USER_UPDATE_DEPOSIT,
  USER_UPDATE_WITHDRAW,
} from "../../../lib/config";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  GetDataFromServer,
  GetDataListFromServer,
  UpdateTransactionDataOnServer,
} from "../../../lib/api";
import { BankOutlined, DollarOutlined } from "@ant-design/icons";
import { setState } from "../../../redux/user";
import { queryHandler } from "../../../lib/global_functions";
import { QUERY_AGENT_BANK } from "../../../lib/query_obj";

const { Text } = Typography;
export default function ConfirmForm({
  closeDrawer,
  detail,
  confirmData,
  rejectData,
  getDataList,
}) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [agentBankList, setAgentBankList] = useState([]);

  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [transactionError, setShowTransactionError] = useState(
    "Transaction ID must be 6 numbers"
  );

  const isAcceptAction = confirmData;
  const transaction = isAcceptAction ? confirmData : rejectData;
  const isWithdraw = confirmData.type === "WITHDRAW";
  const isRejectWithdraw = rejectData.type === "WITHDRAW";

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function getAgentBankData(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AGENT_BANK_LIST,
      queryHandler(filter, QUERY_AGENT_BANK, { page_number, per_page }),
      user.access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        const activeBanks = Array.isArray(res)
          ? res.filter((bank) => bank.is_active === true)
          : [];
        setAgentBankList(activeBanks);
        console.log("active banks", activeBanks);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getAgentBankData(pagin.page_number, pagin.per_page);
  }, []);

  async function handleSubmit(values) {
    setLoading(true);

    const formattedValues = {
      ...Object.fromEntries(
        Object.entries(values).map(([key, value]) => [
          key,
          typeof value === "number" ? value.toString() : value,
        ])
      ),
    };

    const basePayload = {
      ...formattedValues,
      is_approved: isAcceptAction ? true : false,
    };

    const payload =
      !isAcceptAction && isRejectWithdraw
        ? {
            ...basePayload,
            bank_transaction_id: "000000",
            agent_bank_account_id: rejectData.agent_bank_account_id,
          }
        : basePayload;

    const endpoint =
      isWithdraw || isRejectWithdraw
        ? USER_UPDATE_WITHDRAW
        : USER_UPDATE_DEPOSIT;

    await UpdateTransactionDataOnServer(
      endpoint,
      detail.id,
      transaction.id,
      payload,
      user.access_token,
      user.csrf_token
    )
      .then(() => {
        setLoading(false);
        toast.success(
          `${isAcceptAction ? "Approved" : "Rejected"} transaction successfully`
        );
        closeDrawer(true);
        getDataList();
        getRefreshDataList();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }
  function ValidateTransactionId(_, value) {
    if (!value) {
      return Promise.reject();
    }
    const idStr = value.toString();
    if (idStr.length !== 6) {
      setShowTransactionError("Transaction ID must be 6 numbers");
      return Promise.reject(new Error("Transaction ID must be 6 numbers"));
    }
    setShowTransactionError("");
    return Promise.resolve();
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOptions(value) {
    const iconPath = BANK_ICON_MAP[value.bank_type];
    const displayName =
      value.acc_name.length > 10
        ? `${value.acc_name.substring(0, 10)}***`
        : value.acc_name;

    return (
      <Row align="middle" gutter={8}>
        <Col>
          <img
            src={iconPath}
            alt={value.bank_type}
            style={{
              width: 25,
              height: 25,
              verticalAlign: "middle",
              borderRadius: "5px",
            }}
          />
        </Col>
        <Col>
          <Space size={4}>
            <Text>{displayName}</Text>
            <Text type="secondary">-</Text>
            <Text type="secondary">{value.bank_type.replace(/_/g, " ")}</Text>
          </Space>
        </Col>
      </Row>
    );
  }

  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 30, height: 30, marginRight: 8, borderRadius: "5px" }}
        />
      </div>
    );
  }

  const matchedAgentBank = agentBankList.find(
    (bank) => bank.id === confirmData?.agent_bank_account_id
  );

  return (
    <Form
      size={user.ui_size}
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
    >
      <Row gutter={[16, 8]}>
        <Col span={24}>
          {isAcceptAction && (
            <Row gutter={[16, 16]}>
              {!isWithdraw && (
                <>
                  <Col span={10}>Bank Transaction ID</Col>
                  <Col span={12}>{confirmData.bank_transaction_id}</Col>
                </>
              )}

              {isWithdraw && (
                <>
                  <Col span={10}>Last Deposit Bank Type</Col>
                  <Col span={12}>
                    {renderBankOption(confirmData.last_deposit_bank_type)}
                  </Col>
                </>
              )}

              <Col span={10}>User Accont Name</Col>
              <Col span={12}>{confirmData.user_bank?.acc_name}</Col>

              <Col span={10}>User Accont Number</Col>
              <Col span={12}>{confirmData.user_bank?.acc_number}</Col>

              <Col span={10}>User Bank Type</Col>
              <Col span={12}>
                {renderBankOption(confirmData.user_bank?.bank_type)}
              </Col>

              {!isWithdraw && (
                <>
                  <Col span={10}>Agent Account Name</Col>
                  <Col span={12}>{matchedAgentBank?.acc_name || "-"}</Col>

                  <Col span={10}>Agent Account Number</Col>
                  <Col span={12}>{matchedAgentBank?.acc_number || "-"}</Col>

                  <Col span={10}>Agent Bank Type</Col>
                  <Col span={12}>
                    {renderBankOption(matchedAgentBank?.bank_type || "-")}
                  </Col>
                </>
              )}
            </Row>
          )}
        </Col>

        {isWithdraw && (
          <Col span={12} style={{ marginTop: "24px" }}>
            <Form.Item
              label="Transaction ID"
              name="bank_transaction_id"
              rules={[{ required: true }, { validator: ValidateTransactionId }]}
              help={transactionError}
              validateStatus={transactionError ? "warning" : ""}
              hasFeedback
            >
              <Input
                prefix={<DollarOutlined style={{ marginRight: "8px" }} />}
                controls={false}
                placeholder="Transaction ID"
                maxLength={6}
                style={{
                  width: "100%",
                  ...(transactionError === "warning"
                    ? { borderColor: "#faad14" }
                    : {}),
                }}
                onBeforeInput={(e) => {
                  if (!/^[a-zA-Z0-9]$/.test(e.data)) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>
        )}

        {isWithdraw && (
          <Col span={24}>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="Agent Bank Account"
                  name="agent_bank_account_id"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder={
                      <span>
                        <BankOutlined style={{ marginRight: 8 }} />
                        Select Agent Bank
                      </span>
                    }
                    options={agentBankList.map((value) => ({
                      label: renderBankOptions(value),
                      value: value.id,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        )}

        <Col
          span={24}
          style={!isWithdraw && isAcceptAction && { marginTop: "20px" }}
        >
          <Form.Item
            label="Note"
            name="note"
            rules={[
              { max: 200, message: "Note cannot exceed 200 characters!" },
            ]}
          >
            <TextArea rows={5} placeholder="Note..." maxLength={200} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Row justify="end">
          <Col span={12} align="right">
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                danger={!isAcceptAction}
              >
                {isAcceptAction ? "Confirm" : "Reject"}
              </Button>
              <Button onClick={() => closeDrawer(false)}>Cancel</Button>
            </Space>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
}
